import { Box } from '@mui/material'
import { MuiTelInput } from 'mui-tel-input'

type PhoneFieldProps = {
  id: string
  name: string
  label: string
  value: string
  onChange: (value: string) => void
  error?: string
  required?: boolean
}

/**
 * International phone field used on Devices forms.
 * Mirrors ePharmacy `PhoneInput`: the MuiTelInput value is passed straight
 * through to the form so partially typed numbers are never discarded.
 */
export function PhoneField({
  id,
  name,
  label,
  value,
  onChange,
  error,
  required = false,
}: PhoneFieldProps) {
  return (
    <Box sx={{ mb: 2 }}>
      <MuiTelInput
        id={id}
        name={name}
        defaultCountry="GB"
        value={value}
        label={required ? `${label}*` : label}
        onChange={value => onChange(value)}
        error={Boolean(error)}
        helperText={error}
        fullWidth
        variant="outlined"
      />
    </Box>
  )
}
